import { gql } from "@apollo/client";

export const GET_PART_ORDERS = gql`
  query GetPartOrders($query: QueryInput, $partOrder: PartOrderInput) {
    partOrders(query: $query, partOrder: $partOrder) {
      partOrders {
        _id
        id
        requested_date
        ticket_number
        ticket_id
        link
        vendor_part_number
        description
        warranty_type
        status
        ordered_date
        ordered
        vendor
        po_number
        price
        shipping_price
        total_price
        payment_method
        eta
        tracking_number
        received
        received_date
        notes
        created_at
        updated_at
        quantity
        customer {
          _id
          id
          fullname
          business_name
        }
      }
      metaData {
        totalCount
        totalPages
      }
    }
  }
`;
